import { render, staticRenderFns } from "./my-fixed-input.vue?vue&type=template&id=4fecd2f2&scoped=true&"
import script from "./my-fixed-input.vue?vue&type=script&lang=js&"
export * from "./my-fixed-input.vue?vue&type=script&lang=js&"
import style0 from "./my-fixed-input.vue?vue&type=style&index=0&id=4fecd2f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fecd2f2",
  null
  
)

export default component.exports